import { render, staticRenderFns } from "./BookList.vue?vue&type=template&id=400f9545&scoped=true&"
import script from "./BookList.vue?vue&type=script&lang=js&"
export * from "./BookList.vue?vue&type=script&lang=js&"
import style0 from "./BookList.vue?vue&type=style&index=0&id=400f9545&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400f9545",
  null
  
)

export default component.exports